import { usePortalOpportunities } from "../portal/api.js";
import { OpportunityCard } from "../portal/OpportunityCard.js";

/**
 * Inbox (unit 17): every invitation with a conversation, most recent
 * activity first. Unread state is the card's client-side last-seen dot;
 * opening a thread (the detail page) marks it seen.
 */
export function PortalInbox() {
  const { data, isPending } = usePortalOpportunities();

  if (isPending) {
    return (
      <div className="mx-auto max-w-md px-6 py-10">
        <div className="h-6 w-1/2 animate-pulse rounded bg-charcoal/15" />
        <div className="mt-4 h-24 animate-pulse rounded-2xl bg-charcoal/15" />
      </div>
    );
  }

  const threads = (data?.items ?? [])
    .filter((i) => i.lastMessage !== null)
    .sort((a, b) => b.lastMessage!.sentAt.localeCompare(a.lastMessage!.sentAt));

  return (
    <div className="mx-auto max-w-md px-4 py-8">
      <h1 className="px-2 text-xl font-bold text-charcoal">Inbox</h1>
      {threads.length === 0 ? (
        <div className="mt-6 rounded-2xl border border-charcoal/15 bg-white p-6 text-center">
          <p className="text-base text-charcoal">
            Conversations with customers show up here once a thread starts.
          </p>
        </div>
      ) : (
        <div className="mt-4 space-y-3">
          {threads.map((item) => (
            <OpportunityCard key={item.invitationId} item={item} />
          ))}
        </div>
      )}
    </div>
  );
}
